import React, { Component } from 'react';
import PropTypes from 'prop-types';

import playSmall from '../../assets/images/videoPlay.png';
import playMed from '../../assets/images/videoPlay@2x.png';

import './index.css';

class Video extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldDisplayVideo: false,
    };
  }
  render() {
    const { shouldDisplayVideo } = this.state;
    const { playBtnSize, videoUrl, imageUrl } = this.props;
    let playImage = playMed;
    let playStyle = 'playLarge';

    const isVimeo = /vimeo/.test(videoUrl);

    switch (playBtnSize) {
      case 'small':
        playImage = playSmall;
        playStyle = 'playSmall';
        break;
      case 'medium':
        playImage = playMed;
        playStyle = 'playMed';
        break;
      default:
        break;
    }

    const player = isVimeo ?
      (
        <div styleName="vimeoContainer">
          <iframe
            styleName="vimeoMedia"
            title="vimeo player"
            src={`${videoUrl}`}
            frameBorder="0"
            allowFullScreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
          />
        </div>
      ) :
      (
        <video
          styleName="media"
          controls
          src={videoUrl}
          autoPlay
        >
          <track kind="captions" />
        </video>
      );

    return (
      <div styleName="outer">
        {!shouldDisplayVideo && !isVimeo ?
          <input
            type="image"
            id="playButton"
            styleName={playStyle}
            src={playImage}
            alt="Play video"
            onClick={() => {
              this.setState({
                ...this.state,
                shouldDisplayVideo: true,
              });
            }}
          /> : null}
        <div>
          {shouldDisplayVideo || isVimeo ?
            player :
            <img
              src={imageUrl}
              styleName="media"
              alt="Featured offer video thumbnail"
            />
            }
        </div>
      </div>
    );
  }
}

Video.propTypes = {
  playBtnSize: PropTypes.string, // small, medium, large
  videoUrl: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
};

Video.defaultProps = {
  playBtnSize: 'large',
};

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video/index.js